import React from 'react';
import { Avatar } from 'antd';

import color from '../../../../utils/colorFromString';

const AvatarUser = ({ userName, className, size = 'default', onClick, icon = null }) => {
  if (icon) {
    return <Avatar size={size} className={className} onClick={onClick} icon={icon} />;
  }

  const shortName = userName ? color.getShortName(userName) : '👤';
  return (
    <Avatar
      style={{ background: color.colorUserIcon(userName), verticalAlign: 'middle' }}
      size={size}
      className={className}
      onClick={onClick}
    >
      {shortName}
    </Avatar>
  );
};

export default AvatarUser;
